import { Expose } from 'class-transformer';
import { MoviePrintApiModel } from '../movie/movie-print.api.model';
import { MovieApiModel } from '../movie/movie.api.model';

export class ReservationMovieApiModel extends MovieApiModel {
  @Expose()
  moviePrint: MoviePrintApiModel;
}
